import React from 'react';
import PropTypes from 'prop-types';

function Area (props) {
  const item = props.item;
  const property = item.getProperty();
  const room = property.getRoom();
  const landPlot = property.getLandPlot();
  const building = property.getBuilding();

  const totalArea = room.getTotalArea();
  const livingArea = room.getLivingArea();
  const kitchenArea = room.getKitchenArea();
  const landArea = landPlot.getTotalArea();
  const planing = room.getPlanning();
  const balcony = room.getBalcony();
  const size = building.getSizeLabel();

  return (
    <td className='col-area'>
      { totalArea && (<div><span className='main-param'>{totalArea.getLabel(false)}</span></div>) }
      <div>
        {
          [
            (livingArea && livingArea.getLabel()),
            (kitchenArea && kitchenArea.getLabel()),
            (landArea && landArea.getLabel()),
            (planing && planing.get('shortName')),
            (balcony && balcony.get('shortName'))
          ].filter(Boolean).map(el => <div key={el}>{el}</div>)
        }
      </div>
      { size && <div>{'(' + size + ')'}</div> }
    </td>
  );
}

Area.propTypes = {
  item: PropTypes.object.isRequired
};

Area.defaultProps = {};

export default Area;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/Area.jsx